var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pgAdmin"}},[_c('div',{attrs:{"id":"qrCamera"}},[_c('qrcode-stream',{on:{"init":_vm.inicializar,"decode":_vm.salvar}})],1),_c('h1',[_vm._v("Resultado: "+_vm._s(this.valor))])])
}
var staticRenderFns = []

export { render, staticRenderFns }